export default "__VITE_ASSET__f4Zaz_5i__"